module.exports = __webpack_public_path__ + "img/Weapon_250.ae13a806.png";